export enum OrderStatus {
  PENDING = "PENDING",
  PAID = "PAID",
  CANCELLED = "CANCELLED",
  FAILED = "FAILED",
  REVOKED = "REVOKED",
}

export type PaymentOrder = {
  id: string;
  price: number;
  type: "recurring" | "general";
  products: Array<{
    quantity: number;
    product: {
      id: string;
      price: number;
      category: "plan" | "consumable";
      allowedPaymentSystems: { name: string }[];
      items: {
        itemType: "Plan";
        item: {
          id: string;
          title: string;
          tag: string;
          isOneTime: boolean;
          duration: {
            months?: number;
            days?: number;
          };
          description: string;
        };
      }[];
    };
  }>;
  status?: OrderStatus;
  paidAt?: string;
};
